<template>
    <div class="kits-title-header">
        <div class="input-wrap title_radio sub-filter">
            <span class="filter-wrap-custom">
                <select id="locationSelect" class="input-filter custom-width" v-model="selectedLocation" @change="handleLocationChange">
                    <option disabled value="">Select a region</option>
                    <option v-for="location in locations" :key="location.id" :value="location.id">
                    {{ location.location }}
                    </option>
                </select>
            </span>
            <span class="radio-span ml-22">
                <input type="radio" name="type" value="percentage" v-model="type">Percentage
            </span>
            <span class="radio-span">
                <input type="radio" name="type" value="number" v-model="type">Number
            </span>
        </div>
        <div class="title-header">
            <p class="max-kits-error">Please enter the {{ type }} of kit on each kit type.</p>
        </div>
        <div class="percent-input-wrap mt-20">
            <div class="input-wrap">
                <div class="text-center mb-5">
                    <label>F1</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="F1"
                    v-model="percentage.f1"
                    name="f1"
                    :class="{ invalid: errors.has('f1') }"
                    @keypress="validateKeypress($event, 'f1')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('f1')">
                    {{ errors.first("f1") }}
                </span>
            </div>
            <div class="input-wrap ml-15">
                <div class="text-center mb-5">
                    <label>F2</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="F2"
                    v-model="percentage.f2"
                    name="f2"
                    :class="{ invalid: errors.has('f2') }"
                    @keypress="validateKeypress($event, 'f2')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('f2')">
                    {{ errors.first("f2") }}
                </span>
            </div>
            <div class="input-wrap ml-15">
                <div class="text-center mb-5">
                    <label>F3</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="F3"
                    v-model="percentage.f3"
                    name="f3"
                    :class="{ invalid: errors.has('f3') }"
                    @keypress="validateKeypress($event, 'f3')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('f3')">
                    {{ errors.first("f3") }}
                </span>
            </div>
            <div class="input-wrap ml-15">
                <div class="text-center mb-5">
                    <label>R1</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="R1"
                    v-model="percentage.r1"
                    name="r1"
                    :class="{ invalid: errors.has('r1') }"
                    @keypress="validateKeypress($event, 'r1')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('r1')">
                    {{ errors.first("r1") }}
                </span>
            </div>
            <div class="input-wrap ml-15">
                <div class="text-center mb-5">
                    <label>R2</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="R2"
                    v-model="percentage.r2"
                    name="r2"
                    :class="{ invalid: errors.has('r2') }"
                    @keypress="validateKeypress($event, 'r2')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('r2')">
                    {{ errors.first("r2") }}
                </span>
            </div>
            <div class="input-wrap ml-15">
                <div class="text-center mb-5">
                    <label>R3</label>
                </div>
                <input
                    type="text"
                    class="input"
                    placeholder="R3"
                    v-model="percentage.r3"
                    name="r3"
                    :class="{ invalid: errors.has('r3') }"
                    @keypress="validateKeypress($event, 'r3')"
                    @change="updatePercentCount()"
                />
                <span class="validate-error" v-if="errors.has('r3')">
                    {{ errors.first("r3") }}
                </span>
            </div>
            <div class="input-wrap ml-15 mt-20">
                <button
                    class="btn"
                    :disabled="type == 'percentage' && total > 100" 
                    @click="calculateKits"
                >
                    Submit
                </button>
            </div>
        </div>
        <div class="input-wrap percentage" v-if="type == 'percentage'">
            <span class="total-percentage error" v-if="total > 100">
                You should enter a total of 100 percent to submit.
            </span>
            <span class="total-percentage" v-else-if="total > 0">
                Total <span>{{ total }}%</span>
            </span>
        </div>
        <div class="title-header" v-if="type == 'percentage' && Object.keys(feasible).length > 0">
            <p class="max-kits-error mt-10">Number of kits that can be generated</p>
            <div class="table-container">
                <table class="styled-table">
                    <thead>
                        <tr>
                            <th>F1</th>
                            <th>F2</th>
                            <th>F3</th>
                            <th>R1</th>
                            <th>R2</th>
                            <th>R3</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td v-for="(value, index) in feasible" :key="index">{{ value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div> 
        <div class="title-header mt-20 w-100" v-if="type == 'number' && Object.keys(required).length > 0">
            <div class="border-styled">    
                <div class="title-header custom">
                    <!-- <p v-if="insufficientComponentsFlag" class="max-kits-error mt-10">{{ generatedMessage }}</p> -->
                    <!-- <p v-else class="max-kits-error mt-10">All the number of kits mentioned above can be generated.</p> -->
                    <p v-if="insufficientComponentsFlag" class="inventory-title pl-4 mt-20">Inventory Distribution</p>
                </div>
                
                <div class="table-container cus-padd">
                    <div class="table-wrapper gap-2">
                        <div v-for="(items, type) in insufficientComponents" :key="type" v-if="feasible[`feasible_${type}`]" class="kit-type-wrapper">
                            
                            <p>{{ type.toUpperCase() }}</p>
                            <table class="styled-table">
                                <thead>
                                    <tr>
                                        <th>Kits</th>
                                        <th class="text-right">Count</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Total</td>
                                        <td class="text-black text-right">{{ feasible[`feasible_${type}`] }}</td>
                                    </tr>
                                    <tr>
                                        <td>Generatable</td>
                                        <td v-if="maxKits[type] > 0" class="available-count text-right">{{ maxKits[type] }}</td>
                                        <td v-else class="available-count text-right">0</td>
                                    </tr>
                                    <tr>
                                        <td>Additional</td>
                                        <td v-if="maxKits[type] > 0" class="additional-count text-right">{{ feasible[`feasible_${type}`] - maxKits[type] }}</td>
                                        <td v-else class="additional-count text-right">{{ feasible[`feasible_${type}`] }}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <table v-if="Object.keys(items).length" class="styled-table">
                                <thead>
                                    <tr class="bg-light-red">
                                        <th>Add SKU</th>
                                        <th class="text-right">Count</th>
                                    </tr>
                                </thead>
                                <tbody v-if="Object.keys(items).length">
                                    <tr v-for="(quantity, item) in items" :key="item">
                                        <td class="additional-count">{{ item }}</td>
                                        <td class="additional-count text-right">{{ quantity }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div> 
            </div>

            <div v-if="insufficientComponentsFlag" class="title-header custom mt-20">
                <p class="inventory-title">Total Additional Inventory</p>
            </div>
            <div v-if="insufficientComponentsFlag" class="table-container">
                <!-- <div class="table-wrapper">
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>Kits</th>
                                <th>Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Total</td>
                                <td class="text-black">{{ aggregate.feasible }}</td>
                            </tr>
                            <tr>
                                <td>Generatable</td>
                                <td class="available-count">{{ aggregate.maxKits }}</td>
                            </tr>
                            <tr>
                                <td>Additional</td>
                                <td class="additional-count">{{ aggregate.feasible - aggregate.maxKits }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->
                <div class="table-wrapper">
                    <!-- Left Table -->
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>SKU</th>
                                <th class="text-right">Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, index) in leftSku" :key="index">
                                <td :class="required[value] > 0 ? 'additional-count' : ''">{{ value }}</td>
                                <td :class="required[value] > 0 ? 'additional-count text-right' : 'text-right'">{{ required[value] }}</td>
                            </tr>
                        </tbody>
                    </table>
                    
                    <!-- Middle Table -->
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>SKU</th>
                                <th class="text-right">Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, index) in middleSku" :key="index">
                                <td :class="required[value] > 0 ? 'additional-count' : ''">{{ value }}</td>
                                <td :class="required[value] > 0 ? 'additional-count text-right' : 'text-right'">{{ required[value] }}</td>
                            </tr>
                        </tbody>
                    </table>

                    <!-- Right Table -->
                    <table class="styled-table">
                        <thead>
                            <tr>
                                <th>SKU</th>
                                <th class="text-right">Count</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(value, index) in rightSku" :key="index">
                                <td :class="required[value] > 0 ? 'additional-count' : ''">{{ value }}</td>
                                <td :class="required[value] > 0 ? 'additional-count text-right' : 'text-right'">{{ required[value] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <CommonMessageModal
            v-if="message_modal"
            :message="message"
            @closeModal="closeMessageModal"
        ></CommonMessageModal> 
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CommonMessageModal from "../dashboard/CommonMessageModal";

export default {
    name: "KitPercentageForm",
    data() {
      return {
        selectedLocation: '',
        locations: [],
        percentage: {
            f1: null,
            f2: null,
            f3: null,
            r1: null,
            r2: null,
            r3: null
        },
        sku: [
            'F1Label03', 'F2Label03', 'F3Label03', 'PUMP001', 'SHIPPER', 
            'OUTERBOX', 'HANDLE001', 'BOX1', 'BOX1INSERT', 'BOX2', 
            'BOX2INSERT1RM', 'BOX2INSERT2RM', 'BOX2INSERT3RM', '2STAPE', 
            'BATTERYCARD', 'GORILLATAPE', 'AA4PACK', 'MANUAL05', 
            'AIROCELL', 'AIROCELLTABS', 'R1Label03', 'R2Label03', 
            'R3Label03', 'KRAFTMAILER01', 'POLYMAILER01'
        ],
        feasible: {},
        required: {},
        insufficientComponents: {},
        maxKits: {},
        aggregate: {
            maxKits: 0,
            feasible: 0
        },
        insufficientComponentsFlag: false,
        filter_location: null,
        percentage_val: 0,
        message: null,
        message_modal: false,
        type: "percentage"
      };
    },
    components: {
        CommonMessageModal
    },
    methods: {
        ...mapActions([
            "calculateKitCountsByPercentage",
            "setInventory",
            "setPage",
            "setFillocation",
            "setLoader"
        ]),
        handleLocationChange(){
            this.loading = true;
            this.setPage(1);
            this.setFillocation(this.selectedLocation).then(async res => {})
            this.loading = false;
        },
        validateKeypress(event, field) {
            // Allow only digits
            const char = String.fromCharCode(event.which);
            if (!/[0-9]/.test(char)) {
                event.preventDefault();
            }
        },
        closeMessageModal(boolean) {
            this.message_modal = boolean;
        },
        calculateKits() {
            if(this.selectedLocation == '') {
                this.message = 'You should select a region to submit.';
                this.message_modal = true;
                return false;
            }

            if(this.type == 'percentage' && this.percentage_val !== 100) {
                this.message = 'You should enter a total of 100 percent to submit.';
                this.message_modal = true;
                return false;
            }

            this.setLoader(true);
            this.feasible = {};
            this.insufficientComponentsFlag = false;
            this.$emit("updateSubmitted", false);
            this.calculateKitCountsByPercentage({'percentage': this.percentage, 'location': this.filter_location, 'type': this.type}).then(async res => {
                this.feasible = res.data.feasible;

                if(this.type == 'number') { 
                    this.required = res.data.required;
                    this.insufficientComponents = res.data.insufficientComponents;
                    this.maxKits = res.data.maxKits;
                }

                await this.setInventory();
                this.$emit("updateSubmitted", true);
                this.setLoader(false);
            });
        },
        updatePercentCount() {
            this.percentage_val = 0;
            for(let key in this.percentage) {
                this.percentage_val += parseInt((this.percentage[key] || 0))
            }
        }
    },
    computed: {
    ...mapGetters(["getFillocation"]),
    generatedMessage() {
        let result = [];

        for (const [kit, count] of Object.entries(this.maxKits)) {
            if (count && count > 0) {
                result.push(`${count} ${kit.toUpperCase()} kits`);
            }
        }

        if (result.length > 0) {
            if (result.length === 1) {
                return `Using the current inventory, ${result[0]} can be generated.`;
            } else if (result.length === 2) {
                return `Using the current inventory, ${result.join(" and ")} can be generated.`;
            } else {
                const lastItem = result.pop();
                return `Using the current inventory, ${result.join(", ")}, and ${lastItem} can be generated.`;
            }
        } else {
            return "No kits can be generated from the current inventory.";
        }
    },
    leftSku() {
        return this.sku.slice(0, Math.ceil(this.sku.length / 3));
    },
    middleSku() {
        const start = Math.ceil(this.sku.length / 3);
        const end = Math.ceil(2 * this.sku.length / 3);
        return this.sku.slice(start, end);
    },
    rightSku() {
        return this.sku.slice(Math.ceil(2 * this.sku.length / 3));
    },
    total(){
        this.percentage_val = 0;
        for(let key in this.percentage) {
            this.percentage_val += parseInt((this.percentage[key] || 0))
        }
        return this.percentage_val;
    }
    },
    watch: {
        getFillocation(loc){
            this.filter_location = loc;
        },
        async type(){
            this.percentage = {
                f1: null,
                f2: null,
                f3: null,
                r1: null,
                r2: null,
                r3: null
            };
            this.feasible = {};
            this.required = {};
            this.$emit("clearInventory");
        },
        insufficientComponents() {
            this.insufficientComponentsFlag = false;
            let previousCount = {};

            for (let key in this.insufficientComponents) {
                if (Object.keys(this.insufficientComponents[key]).length !== 0) {
                    for (let innerKey in this.insufficientComponents[key]) {
                        if (!previousCount[innerKey]) {
                            previousCount[innerKey] = 0;
                        }

                        this.insufficientComponents[key][innerKey] -= previousCount[innerKey];
                        
                        previousCount[innerKey] = this.insufficientComponents[key][innerKey] + previousCount[innerKey];
                    }
                    this.insufficientComponentsFlag = true;
                }
            }
        }, 
        maxKits() {
            this.aggregate.maxKits = 0;
            for(let key in this.maxKits) {
                if (this.maxKits[key] && this.maxKits[key] > 0) {
                    this.aggregate.maxKits += this.maxKits[key];
                }
            }
        },
        feasible() {
            this.aggregate.feasible = 0;
            for(let key in this.feasible) {
                if (this.feasible[key]) {
                    this.aggregate.feasible += this.feasible[key];
                }
            }
        }
    },
    mounted() {
        this.locations = this.$store.getters.getLocation;
        this.filter_location = this.$store.getters.getFillocation;
    }
}
</script>

<style scoped>
.max-kits-error {
    padding-bottom: 10px;
    color: #43B02A;
    font-size: 14px;
}
.inventory-title {
    padding-bottom: 10px;
    color: #005EB8 !important;
    font-size: 20px;
    font-weight: bold;
}
.close {
    position: absolute;
    right: 15px;
    top: 15px;
    border: 1px solid transparent;
    cursor: pointer;
    width: 15px;
    height: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    background-color: transparent;
}
.formCom {
    background-color: rgba(219, 230, 241, 0.5);
    position: fixed;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 0;
    top: 0;
    z-index: 99;
}
.input.invalid {
    border: 1px solid red;
}
.form {
    padding: 30px;
    background-color: #fff;
    max-width: 350px;
    width: 100%;
    position: relative;
    z-index: 1;
}
.input-wrap {
    width: 100%;
    margin: 0 0 15px 0;
}
.input {
    border: 1px solid #e4e4e4;
    border-radius: 2px;
    padding: 15px 20px;
    color: #4d4d4d;
    width: 100%;
    font-size: 14px;
    font-family: TTNormsLight, sans-serif;
    text-align: center;
    outline: none;
}
.input::placeholder {
    color: #98a4ae;
    font-size: 14px;
    font-family: TTNormsLight, sans-serif;
}
.select {
    height: 45px;
    background-color: #fff;
    color: #98a4ae;
    text-align-last: center;
}
.btn {
    background-color: #005eb8;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    cursor: pointer;
    outline: none;
    border: 1px solid transparent;
    height: 45px;
    border-radius: 25px;
    font-size: 18px;
    transition: all 0.5s linear;
    font-family: TTNormsMedium, sans-serif;
}
.btn.change {
    height: auto;
    width: auto;
    margin: 10px auto 0 auto;
    border-radius: 0px;
    padding: 0;
    color: #005eb8;
    background-color: transparent;
}
.btn:hover:enabled {
    background-color: transparent;
    color: #005eb8;
    border: 1px solid #6cc24a;
}
.btn.change:hover:enabled {
    background-color: transparent;
    color: #005eb8;
    border: 1px solid transparent;
}
/* Styles for the disabled button */
.btn:disabled {
    background-color: #98A4AE; /* Light gray background to indicate it's disabled */
    color: #ccc;              /* Light gray text color */
    cursor: not-allowed;      /* Change cursor to indicate it's not clickable */
    opacity: 0.6;             /* Dim the button slightly */
    border-color: #ccc;       /* Light gray border color */
}
.name {
    color: #005eb8;
    font-size: 24px;
    margin: 0 0 30px 0;
    text-align: center;
    font-family: TTNormsMedium, sans-serif;
}
.txt {
    color: green;
    font-size: 14px;
    margin: 15px 0 0px 0;
    text-align: center;
    font-family: TTNormsMedium, sans-serif;
}
.title_radio {
    color: #005eb8;
    font-size: 15px;
    font-family: TTNormsMedium, sans-serif;
    width: 100%;
    justify-content: space-between;
    cursor: pointer;
}
.percent-input-wrap {
    display: flex;
}
.ml-15 {
    margin-left: 15px;
}
.mt-5 {
    margin-top: 10px;
}
.mt-10 {
    margin-top: 10px;
}
.mt-20 {
    margin-top: 20px !important;
}
.mb-5 {
    margin-bottom: 5px;
}
.kits-title-header{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 0px !important;
}
.title-header {
  color: #005eb8;
  font-size: 20px;
  font-family: TTNormsMedium, sans-serif;
  text-align: center;
}
.title-header .custom {
  text-align: left;
}
.table-container {
  margin: 0 auto;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
  font-size: 14px;
}
.styled-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  font-size: 0.9em;
  text-align: left;
}
.styled-table thead tr {
  background-color: #005eb8;
  color: #ffffff;
  text-align: left;
  height: 37px;
}
.styled-table th, .styled-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr {
  border-bottom: 1px solid #dddddd;
}
.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}
.styled-table tbody tr:last-of-type {
  border-bottom: 2px solid #005eb8;
}
.styled-table tbody tr.active-row {
  font-weight: bold;
  color: #005eb8;
}
.total-percentage {
    color: #005eb8;
    font-size: 14px;
    font-family: TTNormsMedium, sans-serif;
}
.total-percentage.error {
    color: #E10E49; /* Red color for error */
}
.percentage {
    text-align: center;
}
.text-center {
    text-align: center;
}
.text-center label {
    font-family: TTNormsMedium, sans-serif;
}
.table-wrapper {
    display: flex;
    gap: 10px; /* Adjust the space between the tables */
}
.gap-2 {
    gap: 2px !important;
}
.table-container {
    overflow-x: auto; /* To handle horizontal scrolling if needed */
}
.w-100 {
    width: 100%;
}
.border-styled {
    border: 2px solid #d5d5d5;
}
.p-20 {
    padding: 20px;
}
.available-count {
    color: green;
}
.additional-count {
    color: #E10E49;
}
.text-blue {
    color: #005eb8;
}
.text-black {
    color: #000;
}
.kit-type-wrapper {
    padding: 2px;
}
.bg-light-red {
    background-color: #98A4AE  !important;
}
.text-right {
    text-align: right;;
}
.pl-4 {
    padding-left: 4px;
}
.cus-padd {
    padding: 20px 5px;
}
.input-filter {
  padding: 5px 10px;
  color: #373737;
  width: 100%;
  font-size: 16px;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsLight, sans-serif;
  background: white;
}
.custom-width {
    width: 9rem !important;
}
.ml-22 {
    margin-left: 22em;
}
</style>